<template>
  <section id="pricing-plan">
    <!-- pricing plan cards -->
    <b-row class="pricing-card">
      <b-col
        offset-sm-2
        sm="10"
        md="12"
        offset-lg="2"
        lg="10"
        class="mx-auto"
      >
        <b-row>
          <b-col
            v-for="item in requestTypes"
            :key="item.id"
            :md="pricingCols"
          >
            <b-card align="center">
              <h3>{{ item.title }}</h3>
              <b-card-text>
                <div v-html="item.description" />
              </b-card-text>

              <div>
                {{ $t('Start Date') }}:
                <strong>{{ shortDate(item.startDate) }}</strong>
              </div>

              <div>
                {{ $t('End Date') }}:
                <strong>{{ shortDate(item.endDate) }}</strong>
              </div>
              <!-- buttons -->
              <b-button
                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                :to="{
                  name: 'request-submissions-edit',
                  params: {
                    rid: item.id,
                    id: null,
                  },
                }"
                variant="primary"
                block
                class="mt-2"
              >
                {{ $t('New Submission') }}
              </b-button>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import axios from '@/libs/axios'
import Ripple from 'vue-ripple-directive'

export default {
  directives: {
    Ripple,
  },
  data() {
    return {
      requestTypes: [],
    }
  },
  computed: {
    pricingCols() {
      return 6
    },
  },
  mounted() {
    axios.get(`request-types/active`).then(response => {
      this.requestTypes = response.data
    })
  },
}
</script>
